/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:20:57
 */
export default {
  lang: "英语",
  landing: {
    name1: "បើក Carlcare",
    name2: "ធ្វើការកក់ទុក",
    name3: "ជាមួយ Carlcare អ្នកអាចពិនិត្យការបញ្ជាទិញរបស់អ្នកនៅពេលណាក៏បាន។",
    name4: "",
    name5: "អូសទៅខាងស្តាំ",
    name6: "ការផ្ទៀងផ្ទាត់បានបញ្ចប់",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ជ្រើសរើសម៉ូដែលឧបករណ៍",
    name2: "ការពិពណ៌នាពីបញ្ហា៖",
    name3: "ប៉ះដើម្បីជ្រើសរើសហាងសេវាកម្ម",
    name4: "ហាងសេវាកម្ម៖",
    name5: "ពេលវេលាកក់ទុក៖",
    name6: "សូមពិពណ៌នាអំពីបញ្ហាឧបករណ៍របស់អ្នកជាលម្អិត!",
    name7: "ប៉ះដើម្បីជ្រើសរើសពេលវេលាមកដល់",
    name8: "សូមបញ្ចូលព័ត៌មានលម្អិតនៃទំនាក់ទំនងត្រឹមត្រូវរបស់អ្នក ដូច្នេះយើងអាចទាក់ទងអ្នកបាន",
    name9: "ពេលវេលាការកក់ទុកដែលមានគឺដូចតទៅនេះ",
    name10: "សូមបញ្ចូលលេខទូរសព្ទរបស់អ្នក",
    name11: "តម្លៃ",
    name12: "ព័ត៌មានផ្ទាល់ខ្លួន៖",
    name13: "សូម​បញ្ចូល​ឈ្មោះ​របស់​អ្នក",
    name14: "ដាក់​ស្នើ",
    name15: "បោះបង់",
    name16: "យល់ព្រម",
  },
  shops: {
    name1: "ផ្អែកលើម៉ាកដែលអ្នកជ្រើសរើស ហាងដូចខាងក្រោមនេះអាចបម្រើអ្នកបាន!",
    name2: "នឹងមានឆាប់ៗនេះ​នៅក្នុងហាងលក់រាយជាច្រើន! សូមរង់ចាំ!",
  },
  price: {
    name1: "ម៉ាក",
    name2: "ម៉ូដែល",
    name3: "ធាតុ",
    name4: "តម្លៃ",
    name5: "ការរំលឹកជាការគួរសម​៖",
    name6: "តម្លៃទាំងនេះ​គឺសម្រាប់តែជាការយោងប៉ុណ្ណោះ ហើយតម្លៃពិតប្រាកដគឺទៅតាមលក្ខខណ្ឌនៃឧបករណ៍របស់អ្នក។",
    name7: "ប្រសិនបើមិនមាននិមិត្តសញ្ញាពិសេសទេ ឯកតាតម្លៃគឺជាឯកតារូបិយប័ណ្ណក្នុងមូលដ្ឋាន។",
    name8: "សូមអភ័យទោស! មិនមានព័ត៌មានតម្លៃនៅក្នុងតំបន់បច្ចុប្បន្នទេ។",
    name11:"ចំណាយពលកម្ម",
    name12:"តម្លៃសរុប",
    name13: "5. ប្រសិនបើតម្លៃពលកម្មគឺ \"/\" វាមានន័យថាថ្លៃពលកម្មចាំបាច់ត្រូវពិគ្រោះជាមួយហាង។",
    item_main_board: "ក្តារមេ",
    item_screen_frame: "អេក្រង់ (ស៊ុម)",
    item_screen_screen_frame: "អេក្រង់ទីពីរ (ស៊ុម)",
    item_touch_screen: "ប៉ះអេក្រង់",
    item_camera: "\"ម៉ាស៊ីន​ថត\"",
    item_fixed_focus_camera: "កាមេរ៉ាផ្តោតថេរ",
    item_auto_focus_camera: "កាមេរ៉ាផ្តោតស្វ័យប្រវត្តិ",
    item_screen: "អេក្រង់",
    item_secondary_screen: "អេក្រង់ទីពីរ",
    item_fingerprint_module: "ម៉ូឌុលស្នាមម្រាមដៃ",
    item_speaker: "ឧបករណ៍បំពងសំឡេង",
    item_receiver: "អង្គទទួល",
    item_small_board: "បន្ទះតូច",
    item_battery_cover: "គម្របថ្ម",
    item_battery: "ថ្ម",
    item_charger: "ឆ្នាំងសាកថ្ម",
    item_usb_cable: "ខ្សែ USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "មិនមាន​ទិន្នន័យ",
    name2: "អ្នកផ្តល់សេវាកម្ម៖",
    name3: "ម៉ាកសេវាកម្ម៖",
    name4: "ទូរសព្ទ៖",
    name5: "បរិមាណនៃការបញ្ជាទិញ៖",
    name6: "ការផ្ដល់ចំណាត់ថ្នាក់សេវាកម្ម",
    name7: "បរិស្ថានសេវាកម្ម៖",
    name8: "ឥរិយាបថសេវាកម្ម៖",
    name9: "ប្រសិទ្ធភាពសេវាកម្ម៖",
    name10: "គុណភាពសេវាកម្ម៖",
    name11: "ការវាយតម្លៃរបស់អតិថិជន",
    name12:"ទៅ",
    name13:"បានបិទ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "បើក Carlcare",
    name1: "សូមថតរូបអេក្រង់អំពីព័ត៌មានកក់ទុក ហើយរក្សាទុកវាជាបង្កាន់ដៃដើម្បីទទួលបានសេវាកម្មអាទិភាព។",
    name2: "បានដាក់បញ្ជូនដោយជោគជ័យ",
    name3: "1. សម្អាតទិន្នន័យ",
    name4: "សូម​បម្រុងទុក​ទិន្នន័យឯកជនភាព​សំខាន់​នៅលើទូរសព្ទជាមុន",
    name5: "2. បិទពាក្យសម្ងាត់​បើកថាមពល",
    name6: "មុននឹងទៅកាន់​ហាងសេវាកម្ម សូម៖",
    name7: "ហាងសេវាកម្ម៖",
    name8: "ពេលវេលាកក់ទុក៖",
    name9: "ការពិពណ៌នាពីបញ្ហា៖",
    name10: "ម៉ូដែលឧបករណ៍៖",
    name11: "លេខបញ្ជាទិញ៖",
    name12: "ព័ត៌មាន​បញ្ជាទិញ",
  },
  title: {
   
    name1: "គាំទ្រប្រទេសដូចខាងក្រោម៖",
    name2: "ជ្រើសរើសម៉ូដែល",
    name3: "ការកក់",
    name4: "ព័ត៌មានលម្អិតអំពីហាងសេវាកម្ម",
    name5: "ជ្រើសរើសហាងសេវាកម្ម",
  },
  error: {
    
    name1: "គ្មានទិន្នន័យ។ សូមពិនិត្យមើលព័ត៌មានជួសជុលរបស់អ្នក",
    name2: "ត្រូវការជំនួយថែមឬ? សូមទាក់ទងមកយើង។",
    name3: "សូមអភ័យទោស មិនមានមជ្ឈមណ្ឌល Carlcare នៅក្នុងតំបន់បច្ចុប្បន្ននេះទេ។",
    name4: "សូមជ្រើសរើសមជ្ឈមណ្ឌលសេវាកម្មជាមុន",
    name5: "បានបរាជ័យ",
    name6: "សូមជ្រើសរើសម៉ូដែលឧបករណ៍សិន",
    name7: "ព័ត៌មានលម្អិត",
    name8: "សូមពណ៌នាសេចក្តីត្រូវការរបស់អ្នកឲ្យលម្អិត",
    name9: "",
  },
  add1:{
    "name0": "km-rKH",
    "name1": "ការបញ្ជាទិញរបស់អ្នកត្រូវបានបញ្ជាក់។ យើងទន្ទឹងរង់ចាំការមកដល់របស់អ្នក។",
    "name2": "ជ្រើសរើសទីក្រុង",
    "name3": "សូមបញ្ចូលលេខទូរស័ព្ទ %1$s ខ្ទង់។",
    "name4": "ម៉ោងថ្ងៃធ្វើការ",
    "name5": "ថ្ងៃច័ន្ទ",
    "name6": "អង្គារ",
    "name7": "ពុធ",
    "name8": "ព្រហស្បតិ៍",
    "name9": "សុក្រ",
    "name10": "សៅរ៍",
    "name11": "អាទិត្យ",
    "name12": "បញ្ចូលប្រទេស និងស្វែងរក"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "ផ្សេងៗ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ចុចដើម្បីបញ្ជូនបន្ត",
    name3:"បើកកម្មវិធី Carlcare ដើម្បីវាយតម្លៃការបញ្ជាទិញ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ជ្រើសរើសសេវាកម្ម",
    name7:"ការសម្អាតដោយឥតគិតថ្លៃ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ព័ត៌មានមិនត្រឹមត្រូវ",
    "cancelReason1": "មិនអាចមកដល់ទាន់ពេល",
    "cancelReason2": "ការបញ្ជាទិញស្ទួន/មិនមែនការបញ្ជាទិញរបស់ខ្ញុំ",
    "cancelReason3": "ការបរាជ័យមិនបានកើតឡើងវិញទេ",
    "cancelReason4": "គ្រាន់តែដើម្បីធ្វើតេស្ត/សាកសួរ/ព្រឹត្តិការណ៍/…",
    "cancelReason5": "តម្លៃខ្ពស់",
    "cancelReason6": "ការខ្វះខាតវត្ថុធាតុដើម",
    "cancelReason7": "គ្មានសេវាកម្មដែលត្រូវបានញែកឲ្យខុសគ្នាទេ",
    "cancelReason8": "ហាងនៅឆ្ងាយពេក",
    "cancelReason9": "ហាងគឺបិទហើយ",
    "cancelReason10": "ឥរិយាបថផ្ដល់សេវាកម្មអាក្រក់",
    "cancelReason11": "ការប្តូរថ្មី/ការជួសជុលសម្រាប់ម៉ាកដទៃទៀត",
    "cancelReason12": "មិនអាចរកហាងឃើញ",
    "cancelReason13": "ផ្សេងៗ",
    "cancelOrder": "បោះបង់ការបញ្ជាទិញ",
    "reason_dialog_title": "សូមប្រាប់យើងនូវហេតុផលនៃការលុបចោល",
    "Cancel": "បោះបង់ចោល",
    "OK": "យល់ព្រម",
    "name1": "បញ្ចូលលេខកូដដែលបានផ្ទៀងផ្ទាត់",
    "name2": "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ",
    "repair_reservation_detail_canceled": "ការបញ្ជាទិញនេះ​ត្រូវបានលុបចោល!",
    "purchase_cancel_dialog_content": "តើអ្នកបញ្ជាក់ថាបោះបង់ការបញ្ជាទិញនេះដែរទេ?",
    "yes": "បាទ",
    "no": "ទេ"
}
};
